var _excluded = [
  'children',
  'prefixCls',
  'className',
  'ghostPage',
  'padding',
  'footBar',
  'navigationTabs',
  'onNavigationTabsChange',
  'currentNavigationPath',
  'footer',
  'loading',
  'pageBodyClassName',
];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, {
  forwardRef,
  useEffect,
  useContext,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react';
import { PageContainer } from './components/PageContainer';
import { PageContent } from './components/PageContent';
import { PageFoot } from './components/PageFoot';
import { usePrefixCls } from '../utils';
import classNames from 'classnames';
import { PageHeader, Spin } from 'udesk-ui';
import { PageHeaderFooter } from './components/PageHeaderFooter';
import './style/index';
import { PageInfo } from './context/pageInfo';
var _styles = {
  margin: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: 16,
  paddingTop: 16,
  flex: 1,
  overflow: 'auto',
};
var CommonPage = function CommonPage(props) {
  var children = props.children,
    customizePrefixCls = props.prefixCls,
    className = props.className,
    ghostPage = props.ghostPage,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? 16 : _props$padding,
    footBar = props.footBar,
    navigationTabs = props.navigationTabs,
    onNavigationTabsChange = props.onNavigationTabsChange,
    currentNavigationPath = props.currentNavigationPath,
    footer = props.footer,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    pageBodyClassName = props.pageBodyClassName,
    pageHeaderProps = _objectWithoutProperties(props, _excluded);
  var _usePrefixCls = usePrefixCls('common-page', customizePrefixCls),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 2),
    pageContainerPrefixCls = _usePrefixCls2[0],
    prefixCls = _usePrefixCls2[1];
  var _usePrefixCls3 = usePrefixCls('common-page-content', customizePrefixCls),
    _usePrefixCls4 = _slicedToArray(_usePrefixCls3, 1),
    pageContentPrefixCls = _usePrefixCls4[0];
  var _usePrefixCls5 = usePrefixCls('common-page-foot', customizePrefixCls),
    _usePrefixCls6 = _slicedToArray(_usePrefixCls5, 1),
    pageFootPrefixCls = _usePrefixCls6[0];
  var classes = classNames(pageContainerPrefixCls, className);
  var pageBodyClasses = classNames(pageContentPrefixCls, pageBodyClassName);
  return /*#__PURE__*/ React.createElement(
    'div',
    {
      style: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        height: '100%',
      },
    },
    _typeof(pageHeaderProps.title) !== undefined &&
      /*#__PURE__*/ React.createElement(
        PageHeader,
        _objectSpread(
          _objectSpread({}, pageHeaderProps),
          {},
          {
            ghost: false,
            footer: /*#__PURE__*/ React.createElement(PageHeaderFooter, {
              currentNavigationPath: currentNavigationPath,
              antdFooter: footer,
              navigationTabs: navigationTabs,
              onChange: onNavigationTabsChange,
            }),
          },
        ),
      ),
    /*#__PURE__*/ React.createElement(
      'div',
      {
        style: _styles,
      },
      /*#__PURE__*/ React.createElement(
        PageContainer,
        {
          prefixCls: prefixCls,
          className: classes,
        },
        /*#__PURE__*/ React.createElement(
          Spin,
          {
            delay: 200,
            spinning: loading,
          },
          /*#__PURE__*/ React.createElement(
            PageContent,
            {
              ghostPage: ghostPage,
              prefixCls: prefixCls,
              className: pageBodyClasses,
              padding: padding,
            },
            children,
          ),
        ),
      ),
    ),
    footBar
      ? /*#__PURE__*/ React.createElement(
          PageFoot,
          {
            prefixCls: prefixCls,
            className: pageFootPrefixCls,
          },
          footBar,
        )
      : null,
  );
};
var PageInfoMemo = /*#__PURE__*/ forwardRef(function (props, ref) {
  var _useState = useState(_defineProperty({}, window.location.pathname, {})),
    _useState2 = _slicedToArray(_useState, 2),
    pageInfo = _useState2[0],
    _storePageInfo = _useState2[1];
  var storePageInfo = new Proxy(_storePageInfo, {
    apply: function apply(target, ctx, args) {
      window.console.log('location', window.location.pathname);
      var params = _objectSpread(
        _objectSpread({}, pageInfo),
        {},
        _defineProperty(
          {},
          window.location.pathname,
          typeof args[0] === 'function' ? args[0](pageInfo[window.location.pathname]) : args[0],
        ),
      );
      return Reflect.apply(target, ctx, [params]);
    },
  });
  useEffect(
    function () {
      window.console.log('pageInfo ::', pageInfo);
    },
    [pageInfo],
  );
  var clearAllPageInfo = function clearAllPageInfo() {
    storePageInfo(_defineProperty({}, window.location.pathname, {}));
  };
  var pageInfoValue = useMemo(
    function () {
      return new Proxy(
        {
          pageInfo: pageInfo,
          storePageInfo: storePageInfo,
          clearAllPageInfo: clearAllPageInfo,
        },
        {
          get: function get(target, key, receiver) {
            if (key === 'pageInfo') {
              return Reflect.get(target, key, receiver)[window.location.pathname];
            }
            return Reflect.get(target, key, receiver);
          },
        },
      );
    },
    [pageInfo, storePageInfo],
  );
  useEffect(function () {
    return clearAllPageInfo;
  }, []);
  useImperativeHandle(ref, function () {
    return pageInfoValue;
  });
  return /*#__PURE__*/ React.createElement(
    PageInfo.Provider,
    {
      value: pageInfoValue,
    },
    props.children,
  );
});
var usePageStateMemo = function usePageStateMemo() {
  var shouldClearPageStateMemo =
    arguments.length > 0 && arguments[0] !== undefined
      ? arguments[0]
      : function () {
          return false;
        };
  var context = useContext(PageInfo);
  return new Proxy(context, {
    get: function get(target, key, receiver) {
      if (key === 'pageInfo' && shouldClearPageStateMemo()) {
        Reflect.set(target, key, {}, receiver);
      }
      return Reflect.get(target, key, receiver);
    },
  });
};
var RefCommonPage = CommonPage;
RefCommonPage.usePageStateMemo = usePageStateMemo;
RefCommonPage.PageInfoMemo = PageInfoMemo;
export default RefCommonPage;
